import React    from "react";
import * as Dnd from "@dnd-kit/core"

interface DroppableProps {
    droppableArgs:Dnd.UseDroppableArguments,
    children:React.ReactNode
}

interface DraggableProps {
    draggableArgs: Dnd.UseDraggableArguments;
    children: React.ReactNode;
}

export const DraggableSchedulableCell = ({ draggableArgs, children }:DraggableProps ) : JSX.Element =>{
    const { attributes, listeners, setNodeRef, transform, isDragging } = Dnd.useDraggable(draggableArgs);
    const style: React.CSSProperties = {
        transform   : transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
        opacity     : isDragging ? 0.5 : 1,
        cursor      : "grab",
    };
    // Return a <tr> with draggable bindings
    return (
        <td
            ref={setNodeRef}
            {...attributes}
            {...listeners}
            style={style}
        >
            {children}
        </td>
    );
}
export const DraggableUserSpan = ({ draggableArgs, children }: DraggableProps ) : JSX.Element => {
    const { attributes, listeners, setNodeRef, transform, isDragging } = Dnd.useDraggable(draggableArgs);
    return (
        <span 
            ref     = {setNodeRef} 
            style   = {{
                display     : "inline-block", // ✅ prevents siblings from moving
                position    : "relative",
                transform   : transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
                opacity     : isDragging ? 0.5 : 1,
                cursor      : "grab",
                background  : isDragging ? "#eee" : undefined, // optional visual
                padding     : "2px 4px", // optional spacing
                margin      : "2px", // ensures spacing doesn’t collapse
                borderRadius: "4px",
            }}
            {...attributes} 
            {...listeners}
        >
            {children}
        </span>
    );
}
export const DroppableManifestCell = ({ droppableArgs, children }: DroppableProps) : JSX.Element => {
    const { isOver, setNodeRef } = Dnd.useDroppable(droppableArgs);
    return (
        <td
            ref     = {setNodeRef}
            style   = {{
                border      : "2px dashed transparent",
                background  : isOver ? "#d4ffd4" : undefined,
            }}
        >
            {children}
        </td>
    );
}
export const DroppableSchedulableTable = ({ droppableArgs, children }: DroppableProps) : JSX.Element => {
    const { isOver, setNodeRef } = Dnd.useDroppable(droppableArgs);
    return (
        <tbody
            ref     = {setNodeRef}
            style   = {{ 
                verticalAlign: "top", 
                textAlign   : "left", 
                background  : isOver ? "#d4ffd4" : undefined 
            }}
        >
            {children}
        </tbody>
    );
}
export const DroppableVehicleCell = ({ droppableArgs, children }: DroppableProps) : JSX.Element => {
    const { isOver, setNodeRef } = Dnd.useDroppable(droppableArgs);
    return (
        <td
            ref     = {setNodeRef}
            style   = {{
                verticalAlign: "top",
                padding     : 0,
                border      : "2px dashed transparent",
                background  : isOver ? "#d4ffd4" : undefined,
            }}
        >
            {children}
        </td>
    );
}
export const DraggableOrderSpan = ({ draggableArgs, children }: DraggableProps) : JSX.Element => {
    const { attributes, listeners, setNodeRef, transform, isDragging } = Dnd.useDraggable(draggableArgs);
    return (
        <span 
            ref     = {setNodeRef} 
            style   = {{
                display     : "inline-block",
                position    : "relative",
                cursor      : "grab",
                opacity     : isDragging ? 0.5 : 1,
                transform   : transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)`: undefined,
            }}
            {...attributes} 
            {...listeners} 
        >
            {children}
        </span>
    );
}
